// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__LZcgD","title":"Images90_title__20dav","images":"Images90_images__31ld3"};